import type { ReactNode } from 'react';

import type { AvailableIconName } from '@/assets/icons';
import { Stack } from '@/components/layout';
import { SvgIcon, Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { guardianColors } from '@/theme/colors';

type EventDetailInfoRowProps = {
  icon: AvailableIconName;
  label?: string;
  children: ReactNode;
};

export function EventDetailInfoRow({ icon, label, children }: EventDetailInfoRowProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Stack direction="row" align="flex-start" gap={scale(12)}>
      <Stack width={scale(20)} height={scale(24)} align="center" justify="center">
        <SvgIcon name={icon} size={scale(20)} color={guardianColors['6']} />
      </Stack>
      <Stack flex={1} minWidth={0} gap={label ? scale(6) : 0}>
        {label ? (
          <Text variant="Font Guardian App/Subtitle/Subtitle 14 Regular" style={styles.label}>
            {label}
          </Text>
        ) : null}
        {children}
      </Stack>
    </Stack>
  );
}

const useStyles = createStyles(() => ({
  label: {
    color: guardianColors['6'],
  },
}));
